const fabOurTeamEditorConfig = {
  initialContent: {
    title: "",

    card1_image_file: "",
    card1_title: "",
    card1_description: "",
    card1_button_label: "",
    card1_button_link: "",

    card2_image_file: "",
    card2_title: "",
    card2_description: "",
    card2_button_label: "",
    card2_button_link: "",

    card3_image_file: "",
    card3_title: "",
    card3_description: "",
    card3_button_label: "",
    card3_button_link: "",
  },

imageFields: {
  card1: {
    contentKey: "card1_image_file",
  },

  card2: {
    contentKey: "card2_image_file",
  },

  card3: {
    contentKey: "card3_image_file",
  },
},

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      title: templateState.title?.trim() || "",

card1_image_file:
  sharedState.resolvedImageUrls?.card1 || "/ourTeam1.jpg",
      card1_title:
        templateState.card1_title?.trim() || "",
      card1_description:
        templateState.card1_description?.trim() || "",
      card1_button_label:
        templateState.card1_button_label?.trim() || "Learn More",
      card1_button_link:
        templateState.card1_button_link?.trim() || "/contact",

card2_image_file:
  sharedState.resolvedImageUrls?.card2 || "/ourTeam2.jpg",
      card2_title:
        templateState.card2_title?.trim() || "",
      card2_description:
        templateState.card2_description?.trim() || "",
      card2_button_label:
        templateState.card2_button_label?.trim() || "Learn More",
      card2_button_link:
        templateState.card2_button_link?.trim() || "/contact",

card3_image_file:
  sharedState.resolvedImageUrls?.card3 || "/ourTeam3.jpg",
      card3_title:
        templateState.card3_title?.trim() || "",
      card3_description:
        templateState.card3_description?.trim() || "",
      card3_button_label:
        templateState.card3_button_label?.trim() || "Learn More",
      card3_button_link:
        templateState.card3_button_link?.trim() || "/contact",
    };
  },

getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,
}) {
  const card1 = getImageField("card1");
  const card2 = getImageField("card2");
  const card3 = getImageField("card3");

  return {
    templateState,
    setTemplateField,

    card1ImageFile: card1.file,
    setCard1ImageFile: (file) =>
      setImageFile("card1", file),
    existingCard1ImageUrl: card1.existingUrl,
    removeCard1Image: card1.remove,
    setRemoveCard1Image: (remove) =>
      setImageRemoved("card1", remove),

    card2ImageFile: card2.file,
    setCard2ImageFile: (file) =>
      setImageFile("card2", file),
    existingCard2ImageUrl: card2.existingUrl,
    removeCard2Image: card2.remove,
    setRemoveCard2Image: (remove) =>
      setImageRemoved("card2", remove),

    card3ImageFile: card3.file,
    setCard3ImageFile: (file) =>
      setImageFile("card3", file),
    existingCard3ImageUrl: card3.existingUrl,
    removeCard3Image: card3.remove,
    setRemoveCard3Image: (remove) =>
      setImageRemoved("card3", remove),
  };
},
};

export default fabOurTeamEditorConfig;